
Fastweb.Admin.PromotionsForm = (function($) {

  function togglePromotionFormFields(element) {
    class_name = $(element).val();
    $("form > div").each(function(index) {
      if(!$(this).attr('class').match(/Promotion/)) {
        return;
      }
      if( $(this).hasClass(class_name) ) {
        $(this).removeClass('hide');
      } else {
        $(this).addClass('hide');
        $(this).children(":input").val("");
      }
    });
  }

  init = function(promotion_type) {
    $('#' + promotion_type + '_type').on('change', function() {
      togglePromotionFormFields(this);
    });

    if( $('#' + promotion_type + '_type').val() != "" ) {
      togglePromotionFormFields($('#' + promotion_type + '_type'));
    }
  }

  return {init: init}

})(jQuery);
